import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'

import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { Header } from '../../../components/Header/Header'
import { StepItems } from '../../../components/StepItems/StepItems'
import { StepsActions } from '../../../components/StepsActions/StepsActions'

import { TRANSLATION } from '../../constants'
import { ContentContainer, Box } from '../../styles'
import { Item, Steps, Variant } from '../../../types'

import ResumeDistributionDesktop from '../../../assets/Resume-Distribution_Desktop.webm'
import ResumeDistributionMobile from '../../../assets/Resume-Distribution_Mobile.webm'
import ResumeDistributionTablet from '../../../assets/Resume-Distribution_Tablet.webm'

import * as Styles from './styles'

type Props = {
  step: Steps
  variant: Variant
  nextStep?: Steps
  setStep: (step: Steps) => void
  onFinishClick: () => void
}

export const WritingStep = ({ step, variant, setStep, onFinishClick }: Props) => {
  const { i18n } = useI18n()
  const { isPhone, isTablet } = useMediaQueries()

  const KEY = `${TRANSLATION}.onboarding.steps.writing`

  const getSrc = () => {
    if (isPhone) return ResumeDistributionMobile
    if (isTablet) return ResumeDistributionTablet
    return ResumeDistributionDesktop
  }

  const steps: Item[] = [
    {
      icon: 'writing',
      header: i18n.t(`${KEY}.steps.1.header`),
      description: i18n.t(`${KEY}.steps.1.description`),
    },
    {
      icon: 'customization',
      header: i18n.t(`${KEY}.steps.2.header`),
      description: i18n.t(`${KEY}.steps.2.description`),
    },
  ]

  const ActionsContainer = (
    <Styles.ActionsContainer>
      <StepsActions
        variant={variant}
        prevStep={Steps.TEMPLATE}
        activeStep={step}
        setStep={setStep}
        onFinish={onFinishClick}
        backButtonText={i18n.t(`${KEY}.actions.back`)}
        continueButtonText={i18n.t(`${KEY}.actions.continue`)}
      />
    </Styles.ActionsContainer>
  )

  useEffect(() => {
    trackInternalEvent('leads_onboarding_3')
  }, [])

  return (
    <ContentContainer>
      <Box>
        <Styles.InfoContainer>
          <Header
            header={i18n.t(`${KEY}.info.header`)}
            description={i18n.t(`${KEY}.info.description`)}
          />
          <Styles.StepsContainer>
            <StepItems borderTop items={steps} />
          </Styles.StepsContainer>
          {!isPhone && !isTablet && ActionsContainer}
        </Styles.InfoContainer>
      </Box>
      <Box>
        <Styles.VideoContainer>
          <Styles.Video src={getSrc()} autoPlay muted loop playsInline />
          <Styles.VideoInfoContainer>
            <Styles.VideoInfo
              dangerouslySetInnerHTML={{ __html: i18n.t(`${KEY}.animation.title`) }}
            />
          </Styles.VideoInfoContainer>
        </Styles.VideoContainer>
      </Box>
      {(isPhone || isTablet) && ActionsContainer}
    </ContentContainer>
  )
}
